import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiClient } from '@/lib/apiClient'
import { API_ROUTES } from '@/constants/apiRoutes'
import { UserList, UserState } from '@/types/index'

export const getUsers = createAsyncThunk<UserState>(API_ROUTES.ADMIN_USER_ENDPOINT, async () => {
  const res = await apiClient.get<UserState>(API_ROUTES.ADMIN_USER_ENDPOINT)
  return res
})

const initialState: UserList = {
  users: [],
  loading: false,
  error: null,
}

const adminUserSlice = createSlice({
  name: 'adminUser',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET USERS
      .addCase(getUsers.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.users = action.payload.items
        state.loading = false
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.error = action.error.message || 'Error'
        state.loading = false
      })
  },
})

export default adminUserSlice.reducer
